import React from 'react'
import KonvaEditor from "./konva-editor";

const Konva = ({}) => {
    return (
        <>
            <KonvaEditor/>
        </>
    )
}

export default Konva
